import React from 'react';
import httpStatus from 'http-status';
import axios from 'axios';
import { Base64 } from 'js-base64';
import message from '@itt/frontend-scaffold-components/dist/Message/Message';
import ConfirmModal from '@itt/frontend-scaffold-components/dist/ConfirmModal/ConfirmModal';
import STATUS_CODE from './statusCode';
import ERROR_CODE from './errorCode';
import { redirectToLogin, isPrivilegedSession } from '../utils/login';
import theme from '../theme';
import history from '../history';

const getErrorResponse = error => {
  if (error.response) {
    const { status, data, headers } = error.response;
    return {
      statusCode: httpStatus[status],
      data: data && data.error ? data.error : { message: httpStatus[status] },
      location: headers.location
    };
  }
  if (axios.isCancel(error)) {
    return {
      statusCode: STATUS_CODE.CANCELED,
      data: { message: 'Request Canceled' }
    };
  }
  return {
    statusCode: STATUS_CODE.NETWORK_ERROR,
    data: { message: 'Network failure.' }
  };
};

const isUnauthorized = errorResponse => {
  const { statusCode, data } = errorResponse;
  return (
    statusCode === STATUS_CODE.UNAUTHORIZED &&
    (data.code === ERROR_CODE.INVALIDATE_TOKEN ||
      data.code === ERROR_CODE.TOKEN_EXPIRED ||
      data.code === ERROR_CODE.UNAUTHORIZED_WIW_ID ||
      data.code === ERROR_CODE.UNBOUND_WIW_ID)
  );
};

const showPrivilegedSessionExpiredModal = () => {
  ConfirmModal.show({
    title: 'Privileged Session Expired',
    content: (
      <div>
        <div style={{ marginBottom: '8px' }}>
          Your current Privileged Account session has expired.
        </div>
        <div>
          Please return to the Segura Credentials and click the{' '}
          <b>Start Session</b> button to re-authenticate.
        </div>
      </div>
    ),
    onOk: () => {
      return Promise.resolve();
    },
    theme
  });
};

const handleErrorResponse = (errorResponse, showErrorTip) => {
  if (isUnauthorized(errorResponse)) {
    if (isPrivilegedSession()) {
      showPrivilegedSessionExpiredModal();
      return;
    }
    if (errorResponse.location) {
      history.push(
        `/redirect?url=${Base64.encode(
          errorResponse.location
        )}&state=${Base64.encode(window.location.href)}`
      );
    } else {
      ConfirmModal.show({
        content: errorResponse.data.message,
        onOk: () => {
          redirectToLogin();
          return Promise.resolve();
        },
        theme
      });
      return;
    }
  }
  if (
    showErrorTip &&
    errorResponse.statusCode !== STATUS_CODE.CANCELED &&
    !errorResponse.location &&
    errorResponse.data.code !== ERROR_CODE.UNAUTHORIZED_WIW_ID &&
    errorResponse.data.code !== ERROR_CODE.UNBOUND_WIW_ID
  ) {
    message.error(errorResponse.data.message);
  }
};

export { getErrorResponse, handleErrorResponse };
